type TabLike = {
  id: string;
  isActive: boolean;
};

export const resolveActiveTab = <T extends TabLike>(
  tabs: T[],
  activeTabId: string
): T | undefined =>
  tabs.find((tab) => tab.id === activeTabId) ??
  tabs.find((tab) => tab.isActive) ??
  tabs[0];
